import { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { BALANCE_SIDE_CONFIG } from '../config'
import type { BalanceSideConfig } from '../config/balanceSideConfig'
import { BalanceSide } from '../enums/balanceSide'

const BalanceSideContext = createContext<BalanceSideConfig | undefined>(undefined)

interface BalanceSideProviderProps {
  children: ReactNode
  side: BalanceSide
}

export const BalanceSideProvider = ({ children, side }: BalanceSideProviderProps): ReactElement => {
  const config = useMemo(() => BALANCE_SIDE_CONFIG[side], [side])

  return <BalanceSideContext.Provider value={config}>{children}</BalanceSideContext.Provider>
}

export const useBalanceConfig = (): BalanceSideConfig => {
  const context = useContext(BalanceSideContext)

  if (!context) {
    throw new Error('BalanceSideProvider is missing in the module!')
  }

  return context
}

export const useBalanceSide = (): BalanceSide => useBalanceConfig().side
